var _path, _path2, _path3, _path4, _polygon, _circle, _path5, _rect, _path6, _path7, _path8, _rect2, _path9, _path10, _path11, _polygon2, _path12, _rect3, _path13, _rect4, _path14, _path15, _polygon3, _path16, _circle2, _path17, _path18, _path19, _circle3, _path20, _path21, _path22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 678.62,
    height: 555.34,
    viewBox: "0 0 678.62 555.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m547.27,277.22H98.28c-6.78,0-12.29-5.51-12.29-12.29V12.29c0-6.78,5.51-12.29,12.29-12.29h449c6.78,0,12.29,5.51,12.29,12.29v252.64c0,6.78-5.51,12.29-12.29,12.29h-.01ZM98.28,8c-2.37,0-4.29,1.92-4.29,4.29v252.64c0,2.37,1.92,4.29,4.29,4.29h449c2.37,0,4.29-1.92,4.29-4.29V12.29c0-2.37-1.92-4.29-4.29-4.29H98.28Z",
    fill: "#d7d7d8",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m678.62,552.67c0,.83-.67,1.5-1.5,1.5H1.5c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h675.62c.83,0,1.5.67,1.5,1.5Z",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "uuid-c52e1818-0c73-47dc-abde-68b2edf036f9-43-43",
    d: "m322.35,276.07c3.06,6.85,1.82,14.08-2.76,16.17-4.58,2.08-10.78-1.78-13.84-8.63-1.26-2.72-1.82-5.72-1.63-8.75l-12.58-29.18,14.52-6.05,10.86,29.41c2.38,1.86,4.24,4.27,5.42,7.03h.01Z",
    fill: "#a0616a",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m223.33,109.3s21.39-8.15,25.46-2.25,69.36,154.07,69.36,154.07l-32.97,7.92-61.85-159.73h0Z",
    fill: "#d7d7d8",
    strokeWidth: 0
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "229.78 121.7 255.4 130.12 255.4 93.25 232.16 93.25 229.78 121.7",
    fill: "#a0616a",
    strokeWidth: 0
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 252.23,
    cy: 77.93,
    r: 25.52,
    fill: "#a0616a",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m245.73,79.93l3.52,4.27,6.36-11.14s8.12.42,8.12-5.61,7.45-6.2,7.45-6.2c0,0,10.55-18.42-11.3-13.57,0,0-15.16-10.38-22.69-1.51,0,0-23.11,11.64-16.5,31.9l10.99,20.89,2.49-4.73s-1.51-19.85,11.56-14.32v.02Z",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 222.11,
    y: 504.36,
    width: 20.94,
    height: 29.71,
    fill: "#a0616a",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m240.73,551.09c-3.58.32-21.5,1.74-22.4-2.37-.82-3.77.39-7.71.56-8.25,1.72-17.14,2.36-17.33,2.75-17.44.61-.18,2.39.67,5.28,2.53l.18.12.04.21c.05.27,1.33,6.56,7.4,5.59,4.16-.66,5.51-1.58,5.94-2.03-.35-.16-.79-.44-1.1-.92-.45-.7-.53-1.6-.23-2.68.78-2.85,3.12-7.06,3.22-7.23l.27-.48,23.8,16.06,14.7,4.2c1.11.32,2,1.11,2.45,2.17h0c.62,1.48.24,3.2-.96,4.28-2.67,2.4-7.97,6.51-13.54,7.02-1.48.14-3.44.19-5.64.19-9.19,0-22.61-.95-22.71-.97h0Z",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m269.79,248.22l-54.93-2.81s-8.42,31.92,2.22,65.18l1.28,200.29h31.04l29.26-206.61-8.87-56.05h0Z",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m260.52,114.62l-30.15-16s-32.49,47.48-28,73.2c4.5,25.72,12.48,73.6,12.48,73.6l66.51,2.81-11.61-94.29-9.23-39.32Z",
    fill: "#d7d7d8",
    strokeWidth: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 504.36,
    width: 20.94,
    height: 29.71,
    fill: "#a0616a",
    strokeWidth: 0
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m255.62,551.09c-3.58.32-21.5,1.74-22.4-2.37-.82-3.77.39-7.71.56-8.25,1.72-17.14,2.36-17.33,2.75-17.44.61-.18,2.39.67,5.28,2.53l.18.12.04.21c.05.27,1.33,6.56,7.4,5.59,4.16-.66,5.51-1.58,5.94-2.03-.35-.16-.79-.44-1.1-.92-.45-.7-.53-1.6-.23-2.68.78-2.85,3.12-7.06,3.22-7.23l.27-.48,23.8,16.06,14.7,4.2c1.11.32,2,1.11,2.45,2.17h0c.62,1.48.24,3.2-.96,4.28-2.67,2.4-7.97,6.51-13.54,7.02-1.48.14-3.44.19-5.64.19-9.19,0-22.61-.95-22.71-.97h0Z",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m281.36,248.22l-66.51-2.81s-8.42,31.92,2.22,65.18l12.86,200.29h31.04l29.26-206.61-8.87-56.05h0Z",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m353.37,95.3l-4.21,10.53s-3.88,14.74.67,20.62c4.54,5.87,5.55,50.88.67,54.2-4.88,3.33,61.85-30.82,61.85-30.82,0,0-26.05-60.41-26.49-60.63s-17.51-5.54-17.51-5.54l-14.96,11.64h-.02Z",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "396.82 147.35 374.46 154.7 374.46 122.52 394.75 122.52 396.82 147.35",
    fill: "#f3a3a6",
    strokeWidth: 0
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "uuid-f450c430-a5ee-4011-8052-213fac12a506-44-44",
    d: "m328.48,330.06c-1.21,7.37-6.13,12.66-10.98,11.81s-7.81-7.52-6.59-14.9c.44-2.95,1.61-5.75,3.41-8.14l5.54-31.17,15.08,3.16-7.07,30.39c.93,2.88,1.14,5.91.61,8.85h0Z",
    fill: "#f3a3a6",
    strokeWidth: 0
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 367.48,
    y: 507.64,
    width: 20.94,
    height: 29.71,
    fill: "#f3a3a6",
    strokeWidth: 0
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m347.08,555.34c-2.2,0-4.16-.05-5.64-.19-5.56-.51-10.87-4.62-13.54-7.02-1.2-1.08-1.58-2.8-.96-4.28h0c.45-1.06,1.34-1.86,2.45-2.17l14.7-4.2,23.8-16.06.27.48c.1.18,2.44,4.39,3.22,7.23.3,1.08.22,1.98-.23,2.68-.31.48-.75.76-1.1.92.43.45,1.78,1.37,5.94,2.03,6.07.96,7.35-5.33,7.4-5.59l.04-.21.18-.12c2.89-1.86,4.67-2.71,5.28-2.53.38.11,1.02.31,2.75,17.44.17.54,1.38,4.48.56,8.25-.89,4.1-18.81,2.69-22.4,2.37-.1.01-13.52.97-22.71.97h0Z",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 436.55,
    y: 487.59,
    width: 20.94,
    height: 29.71,
    transform: "translate(-198.16 312.67) rotate(-31.95)",
    fill: "#f3a3a6",
    strokeWidth: 0
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m424.45,551.26c-2.46,0-4.72-.3-6.33-.58-1.58-.28-2.82-1.54-3.08-3.12h0c-.18-1.14.15-2.29.93-3.14l10.25-11.34,11.7-26.22.48.26c.18.1,4.39,2.43,6.56,4.43.83.76,1.24,1.57,1.22,2.4-.01.58-.23,1.04-.45,1.37.6.16,2.23.22,6.11-1.42,5.66-2.39,3.42-8.41,3.32-8.66l-.08-.2.09-.19c1.47-3.11,2.52-4.77,3.14-4.94.39-.11,1.03-.28,11.56,13.35.43.36,3.54,3.07,4.84,6.7,1.41,3.95-14.54,12.24-17.75,13.86-.1.08-16.79,12.21-23.65,15.66-2.72,1.37-5.94,1.79-8.87,1.79h0Z",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m403.84,259.19h-58.63l-5.32,54.54,23.28,201.52h29.93l-11.97-116.39,48.55,105.08,26.6-18.62-37.91-98.1s13.54-85.46,2.9-106.75c-10.64-21.28-17.43-21.28-17.43-21.28h0Z",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "433 262.52 331.24 262.52 367.82 142.14 408.39 142.14 433 262.52",
    fill: "#d7d7d8",
    strokeWidth: 0
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m374.22,142.16s-25.27-.67-27.93,5.99c-2.66,6.65-33.92,164.94-33.92,164.94h20.62l41.24-170.93h0Z",
    fill: "#d7d7d8",
    strokeWidth: 0
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 377.23,
    cy: 109.15,
    r: 22.28,
    fill: "#f3a3a6",
    strokeWidth: 0
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m381.55,74.53s26.82-6.87,35.03,28.82c0,0,.22,9.31,4.88,13.08,4.66,3.77,3.1,23.28,3.1,23.28,0,0,8.87,14.63,1.33,21.28,0,0-3.33,13.52,1.55,21.28,4.88,7.76,23.28,50.44-7.32,53.04,0,0-15.52-9.37-8.2-37.3s-.89-43.36-.89-43.36c0,0-23.5-8.52-22.17-26.7,1.33-18.18-15.08-36.14-16.18-35.91s-12.64-6.43-17.74,13.97l-5.46-.93s-2.3-34.32,32.07-30.55h0Z",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "uuid-9eddf5c4-2f7a-4726-a76c-aae8033e4ce6-45-45",
    d: "m450.37,326.48c1.49,7.32-1.24,14.01-6.08,14.94s-9.97-4.26-11.45-11.58c-.63-2.92-.53-5.94.29-8.82l-5.89-31.11,15.22-2.41,4.19,30.92c1.89,2.36,3.16,5.12,3.72,8.06h0Z",
    fill: "#f3a3a6",
    strokeWidth: 0
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m390.67,142.3s22.26-2.82,24.92,3.83c2.66,6.65,33.92,164.94,33.92,164.94h-20.62l-38.22-168.77Z",
    fill: "#d7d7d8",
    strokeWidth: 0
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 383.92,
    cy: 261.75,
    r: 90.89,
    fill: "#6c63ff",
    strokeWidth: 0
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m398.03,215.17c-6.17,20.64-12.34,41.28-18.52,61.92-3.41-5.76-6.82-11.52-10.22-17.28-3.4-5.75-12.38-.53-8.96,5.24,5.43,9.17,10.85,18.34,16.28,27.51,2.31,3.9,8.21,3.02,9.49-1.24,7.32-24.46,14.63-48.93,21.95-73.39,1.92-6.41-8.1-9.16-10.01-2.76h-.01Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "uuid-fd0b6d31-b6bc-427b-94c5-3a25d71a01ed-46-46",
    d: "m332.11,289.65c3.92,6.36,3.67,13.58-.55,16.12s-10.82-.56-14.74-6.92c-1.6-2.52-2.55-5.4-2.77-8.38l-16.25-27.17,13.46-7.51,14.59,27.58c2.59,1.56,4.74,3.72,6.27,6.28h-.01Z",
    fill: "#a0616a",
    strokeWidth: 0
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m212.56,137.34s19.92-10.32,24.71-5c4.79,5.33,88.71,143.13,88.71,143.13l-31.33,11.36-82.1-149.49h.01Z",
    fill: "#d7d7d8",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg1);
export default __webpack_public_path__ + "static/media/svg-1.e09b52ca7a8f2cacc83b69534b2c53d8.svg";
export { ForwardRef as ReactComponent };